// next-i18next.config.js

const path = require("path");

module.exports = {
  i18n: {
    defaultLocale: "tr",
    locales: ["tr", "en"]
  },
  defaultNS: "common",
  fallbackNS: "common",
  ns: ["common"],
  localePath: typeof window === "undefined" ? path.resolve("./public/locales") : "/locales",
  reloadOnPrerender: process.env.NODE_ENV === "development",
  nsSeparator: "."
};
